// Queue events before globalThis.utag is ready
const eventQueue: any[] = [];

const sendTealiumEvent = ([method, args]: any, { utag }: any = globalThis) => {
  return utag && utag[method](...args);
};

export function dataLayerPush(dataLayerObj: any, win: any = globalThis) {
  win.utag_data = { ...win.utag_data, ...dataLayerObj };
}

export function drainQueue(queue = eventQueue, win = globalThis) {
  // Push will now send straight to globalThis.utag
  queue.push = sendTealiumEvent;
  while (queue.length) sendTealiumEvent(queue.shift(), win);
}

export function loadUtag(
  accountProfileEnv: any,
  appendTarget: any = document.head,
  onload: any = drainQueue,
  win: any = globalThis,
) {
  // Original snippet:
  // (function(a,b,c,d){
  //   a=`//tags.tiqcdn.com/utag/${accountProfileEnv}/utag.js`;
  //   b=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;d.async=true;
  //   a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);
  // })();

  // https://docs.tealium.com/platforms/javascript/settings/#noview
  win.utag_cfg_ovrd = { ...win.utag_cfg_ovrd, noview: true };
  const script = document.createElement('script');
  script.async = true;
  script.setAttribute('data-ot-ignore', '');
  script.onload = () => onload(); // addition for event queue
  script.src = `https://tags.tiqcdn.com/utag/${accountProfileEnv}/utag.js`;
  appendTarget.appendChild(script);
}

export const utag = (method: any, args: any, queue: any = eventQueue) => queue.push([method, args]);
